import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { Capability, FeatureFlag } from '__types__';
import useRestrictedAccess from './useRestrictedAccess';

type RestrictedRouteProps = RouteProps & {
  flag?: FeatureFlag;
  capability?: Capability;
};

const RestrictedRoute = ({
  flag,
  capability,
  ...rest
}: RestrictedRouteProps) => {
  const allowed = useRestrictedAccess(flag, capability);
  if (allowed) {
    return <Route {...rest} />;
  }
  return (
    <Route render={props => <Redirect {...props} to={`/unauthorized`} />} />
  );
};

export default RestrictedRoute;
